import React, { useEffect, useState } from "react";
import cs from "classnames";
import { useWishlist } from "../../../lib/hooks/useWishlist";
import { Button } from "../Button/Button";
import { Icon } from "../Icon/Icon";

import "./WishListButton.scss";
import { useMenuSidebar } from "../../../lib/context/MenuSidebarContext/MenuSidebarContext";

interface Props {
  id: number;
}

export const WishListButton = (props: Props) => {
  const menuCtx = useMenuSidebar();
  const { addToWishlist, isProductOnWishList, removeItem } = useWishlist();
  const [isFavorite, setIsFavorite] = useState(isProductOnWishList(props.id));

  const handleClick = () => {
    if (isProductOnWishList(props.id)) {
      removeItem(props.id);
      setIsFavorite(false);
      menuCtx.openSidebar("wishlist");
      return;
    }

    addToWishlist(props.id);
    setIsFavorite(true);
  };

  useEffect(() => {
    if (!isProductOnWishList(props.id)) {
      setIsFavorite(false);
    }
  }, [menuCtx.wishtlist]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Button
      color="pink"
      className={cs("WishListButton", isFavorite && "WishListButton--fill")}
      onClick={handleClick}
    >
      <Icon icon="heart" />
    </Button>
  );
};
